module.exports = __webpack_public_path__ + "fefc472d766ddc53f98fef7a6a8825cf.svg";